var _path, _path2, _path3, _g, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlagOfSlovenia(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 600,
    viewBox: "0 0 12 6",
    width: 1200,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0 0h12v6h-12z",
    fill: "#f00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m0 0h12v4h-12z",
    fill: "#005ce5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m0 0h12v2h-12z",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.02100012 0 0 .02100012 -.106483 3.477988)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m299.9707 105.20898c-1.34275.00213-2.6819.02963-4.01758.06836-25.9762.67332-50.36351 7.38146-67.72851 15.5625l.00195.02344c-1.8988.7936-3.75877 1.58919-5.52734 2.38477l5.96875 93.49023c4.13555 48.85561 35.97434 77.30103 71.34961 88.4707 35.37527-11.16967 67.21212-39.61509 71.34765-88.4707l5.93555-93.19336c-1.77218-.91732-3.63053-1.80653-5.52734-2.68164l.00195-.02344c-18.25122-8.59856-44.25699-15.58263-71.71484-15.6289-.02026-.00004-.04029-.00193-.06055-.00196-.0098.00002-.0195-.00001-.0293 0z",
    fill: "#005ce5",
    fillRule: "evenodd",
    strokeWidth: 2.100012,
    transform: "matrix(.47618776 0 0 .47618776 5.07059 -165.61753)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m147.93437-84.711566-8.31445 16.236187-5.37524-6.98291-14.04559 18.561778c.25384 1.15219.55195 2.264368.87746 3.350324 1.56869 2.647443 4.58316 5.669782 8.44944 5.66978 3.06807 0 6.13613-2.454448 9.20419-2.45445 3.06807 0 6.13613 2.454452 9.20419 2.45445 3.06806 0 6.13612-2.454448 9.20419-2.45445 3.06806 0 6.13612 2.454452 9.20419 2.45445 3.83134 0 6.82572-2.966174 8.40649-5.596146.3374-1.115063.64046-2.263565.90201-3.448503l-14.02719-18.537233-5.37524 6.98291zm-9.20419 36.835159c-3.06806 0-6.13612 2.454452-9.20419 2.45445-2.42818 0-4.51412-.86-6.12998-2.080147.57062 1.211079 1.17422 2.388922 1.8347 3.503728 1.26575.787052 2.70426 1.319269 4.29528 1.319267 3.06807 0 6.13613-2.454452 9.20419-2.45445 3.06807 0 6.13613 2.454454 9.20419 2.45445 3.06806 0 6.13612-2.454452 9.20419-2.45445 3.06806 0 6.13612 2.454454 9.20419 2.45445 1.56857 0 2.98703-.52035 4.24006-1.288587.66018-1.111198 1.26336-2.284992 1.8347-3.491455-1.6082 1.197358-3.67487 2.037194-6.07476 2.037194-3.06807 0-6.13613-2.454448-9.20419-2.45445-3.06807 0-6.13613 2.454452-9.20419 2.45445-3.06806 0-6.13612-2.454448-9.20419-2.45445zm0 5.197298c-3.06806 0-6.13612 2.454454-9.20419 2.45445-.66657 0-1.30044-.07808-1.91447-.196356 5.30791 7.091078 12.54952 11.837649 20.31671 14.56716 7.75116-2.725014 14.98132-7.474976 20.28603-14.554888-.6005.11285-1.22106.184084-1.87151.184084-3.06807 0-6.13613-2.454446-9.20419-2.45445-3.06807 0-6.13613 2.454454-9.20419 2.45445-3.06806 0-6.13612-2.454446-9.20419-2.45445z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "a",
    fill: "#ffe500",
    transform: "translate(0 -.00067)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "m134.0937-109.56066h6.96082l-3.48041 6.02733",
    fill: "#ffe500",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#ffe500",
    height: 300,
    transform: "matrix(1 0 0 -1 .0003 -215.1037)",
    width: 600,
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#ffe500"
  }, /*#__PURE__*/React.createElement("use", {
    height: 300,
    transform: "translate(20.7203)",
    width: 600,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    height: 300,
    transform: "translate(10.3603 13.875)",
    width: 600,
    xlinkHref: "#a"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m249.61914-221.19336c-1.38627.002-2.76778.0311-4.14648.0723 1.3787-.0368 2.75957-.0702 4.14648-.0723zm-71.74805 15.6543c-1.89939.79383-3.75825 1.58896-5.52734 2.38476l5.96875 93.49219c4.13555 48.855608 35.97239 77.299081 71.34766 88.468751 35.37527-11.16967 67.21212-39.613143 71.34765-88.468751l5.93555-93.19531c-1.77228-.91738-3.63042-1.80649-5.52734-2.68164l-5.53907 92.78125c-3.83911 47.499554-33.39281 75.154029-66.23242 86.013669-32.83961-10.85964-62.39526-38.514115-66.23437-86.013669z",
    fill: "#f00",
    fillRule: "evenodd",
    strokeWidth: 2.100012,
    transform: "matrix(.01 0 0 .01 .503574 3.264023)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagOfSlovenia);
export default __webpack_public_path__ + "static/media/Flag_of_Slovenia.b43fa0a03af71458da6634ce271e86d3.svg";
export { ForwardRef as ReactComponent };